// import { Injectable } from '@angular/core';
// import { CanActivate, Router } from '@angular/router';
// import { ConsentToAccessService } from '../../module/consent-to-access/consent-to-access.service';

// @Injectable({
//   providedIn: 'root'
// })
// export class AuthGuard implements CanActivate {

//   constructor(private consentAccessService: ConsentToAccessService, private router: Router) {}

//   canActivate(route: any): boolean {
//     if (this.consentAccessService.isLoggedIn) {
//       return true;
//     } else {
//       this.router.navigate(['/home/landing']); // Redirect to login page if not authenticated
//       return false;
//     }
//         // Check if the route requires a specific role
//         const requiredRole = route.data.role;
//         console.log(requiredRole);
//   }

// }
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { ConsentToAccessService } from '../../module/consent-to-access/consent-to-access.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router,
  public consentDataAcess: ConsentToAccessService,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const currentUrl = route['_routerState'].url;

    // Allow privacy policy page without authentication
    if (currentUrl.includes('/home/privacy-policy')) {
      return true;
    }

    const lastupdate_goldenrecord_date = sessionStorage.getItem('lastupdate_goldenrecord_date');
    const userData = JSON.parse(sessionStorage.getItem('userData') || '{}');
    const requiredRole = route.data['role'];
    // Scenario 1: If no user data (not logged in), redirect to home/landing
    if(requiredRole =='ekyc')
    {
            this.router.navigate(['/home/landing']);
      return false;
    }
    if (!userData || !userData.usercategory && requiredRole=='home') {
     // this.router.navigate(['/home/landing']);
      return true;
    }
    if (!userData || !userData.usercategory && (requiredRole=='citizen')) {
      this.router.navigate(['/home/landing']);
      return false;
    }
    if (!userData || !userData.usercategory && (requiredRole=='vle')) {
      this.router.navigate(['/home/landing']);
      return false;
    }
    // Scenario 2: If user is a VLE, redirect to the VLE dashboard
    if (userData.usercategory === 'vle' && (requiredRole=='home' || requiredRole=='citizen')) {
      if(currentUrl=='/citizen/support' || requiredRole=='home' )
      {
        return true;
      }
      if(requiredRole=='citizen' && userData.citizen_unique_id!=null )
      {
        return true;
      }

      this.router.navigate(['/vle/my-dashboard']);
      return false;
    }

    // Scenario 3: If user is a Citizen, redirect to the Citizen dashboard
    if (userData.usercategory === 'citizen' && (requiredRole=='home' || requiredRole=='vle')) {
      if(currentUrl=='/citizen/support' || requiredRole=='home')
      {
        return true;
      }
      this.router.navigate(['/citizen/scheme/dashboard']);
      return false;
    }

    if (requiredRole == 'citizen' && !currentUrl.startsWith('/ekyc-process')) {
      const isRemind = Number(sessionStorage.getItem('diff_in_days')) <= 0;
      if (isRemind) {
        this.router.navigate(['/ekyc-process']);
        return false;
      }
    }


    // if (requiredRole && userData.usercategory !== requiredRole && userData.lastupdate_goldenrecord_date) {
    //   // If the user's role doesn't match the required role, redirect to an unauthorized page
    //   this.router.navigate(['/unauthorized']);
    //   return false;
    // }
      if (requiredRole !='wait-condition' && requiredRole!='vle' && lastupdate_goldenrecord_date == 'false') {
      // If the user's role doesn't match the required role, redirect to an unauthorized page
      //this.router.navigate(['/wait']);
         this.router.navigate(['/wait']);
      return false;
    }

    // Force eKYC reminder: while isRemind is true, any citizen route (other than
    // ekyc-process itself) redirects to /ekyc-process, even on a manually typed URL.
    if (requiredRole == 'citizen' && !currentUrl.startsWith('/ekyc-process')) {
      const isRemind = Number(sessionStorage.getItem('diff_in_days')) <= 0;
      if (isRemind) {
        this.router.navigate(['/ekyc-process']);
        return false;
      }
    }

    // If everything checks out, allow the user to access the route
    return true;
  }

}

